import { Card, CardContent } from "@mui/material";
import "./sidebar/Sidebar.scss";

export function ErrorFallback({ error, resetErrorBoundary }: any): any {
  return (
    <Card className='error-card' sx={{
        width:{xs:'88%', md:'40%'},
        translate:{xs:'',md:'57% 28%'},
        height:{xs:'65vh',md:'40vh'},
        padding:{xs:'15px',md:'30px'}
        }}>
      <CardContent sx={{translate:'0% 20%'}}>
        <div className="overlay">
          <h1 className="fw-700 grey-color fs-40">Oh no!</h1>
          <p className="grey-color fw-500 fs-22 m-0">
            Something went wrong, We'll clean up and try again.
          </p>
          <button className="btn-danger fs-16" onClick={resetErrorBoundary}>Try again</button>
        </div>
      </CardContent>
    </Card>
  );
}
export const myErrorHandler = (
  error: Error,
  info: { componentStack: string }
) => {
  // Do something with the error
  // E.g. log to an error logging client here
};
